<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";

interface Props {
  text?: string;
  icon?: string;
  iconSVG?: SVGName;
}

defineProps<Props>();

defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'px-2 py-[1rem] flex gap-3 items-center text-left rounded-lg hover:bg-neutral50',
      'focus-visible-strong',
    ]"
    @click="$emit('click')"
  >
    <div
      v-if="icon"
      class="w-6 h-6 min-w-6 min-h-6 flex justify-center items-center"
    >
      <i class="text-xl" :class="icon"></i>
    </div>

    <SVG v-if="iconSVG" :icon="iconSVG" height="1.25rem" width="1.25rem"></SVG>

    <div v-if="text" class="b300 flex-grow">{{ text }}</div>
  </button>
</template>
